import { IUserPrivilege } from "@/shared/model/user-privilege.model";
import { IProject } from "@/shared/model/project.model";

export interface IPermission {
  id?: number;
  createPermission?: boolean | null;
  readPermission?: boolean | null;
  updatePermission?: boolean | null;
  deletePermission?: boolean | null;
  userPrivilege?: IUserPrivilege | null;
  project?: IProject | null;
}

export class Permission implements IPermission {
  constructor(
    public id?: number,
    public createPermission?: boolean | null,
    public readPermission?: boolean | null,
    public updatePermission?: boolean | null,
    public deletePermission?: boolean | null,
    public userPrivilege?: IUserPrivilege | null,
    public project?: IProject | null
  ) {
    this.createPermission = this.createPermission ?? false;
    this.readPermission = this.readPermission ?? false;
    this.updatePermission = this.updatePermission ?? false;
    this.deletePermission = this.deletePermission ?? false;
  }
}
